import { Config } from './types';

export const CONFIG: Config = {
  preloaderDuration: 1800,
  scrollThreshold: 80,
  animationDelay: 150,
  resizeDebounce: 200,
  typewriterSpeed: 40,
  counterDuration: 1500,
  scrollOffset: 50
};